import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Http } from '@angular/http';
import { DataService } from '../services/data.service';
import { SplineComponent } from '../charts/spline';
import { StackedColumnComponent } from '../charts/stackedcolumn';
import { DashboardDataUtility } from '../utils/data.calculate';
import * as _ from 'lodash';
// import { SyncService } from '../connect/syncService';
//import { DataStore } from '../utils/utils';

const RE_RENDER_GRAPH = "rerender-graph";
const RE_RENDER_STACKEDCOLUMN_GRAPH = "rerender-stackedcolumn-graph";
const RE_RENDER_COLUMN_GRAPH = "rerender-column-graph";
const RE_RENDER_SPLINE_GRAPH = "rerender-spline-graph";

@Component({
    selector: 'my-graph',
    template: require('./graphView.html'),
    styles: [require('./graphView.css')]
})
export class GraphView implements OnInit {
    private tableData: string = "Hello";
    public warehouseData: any;
    private warehouseDataPromise: Promise<any>;
    private chartoptions: any = {};
    private categorylabels: Array<any> = [];
    private serieslabels: Array<any> = [];
    private legendlabels: Array<any> = [];    
    private data: any = {};
    private min: number;
    private max: number;
    private dataLoaded: boolean = false;
    private chartStacking: string;
    //private yAxisTickInterval: number = 1;
    @Input() calculatedData: Array<any>;
    @Input() questionsString: string;
    @Input() questionLabels: string;
    @Input() charttitle: string;
    @Input() chartType: string;
    @Input() selectedComponent: string;
    @Input() selectedCompType: string;
    @Input() dataFormat: string;
    @Input() moment: any;
    @Input() columnType:any;
    @Input() stackArray:any;

    //@ViewChild(SplineComponent) chartData: SplineComponent;
    //@ViewChild(StackedColumnComponent) stackedcolumnchartData: StackedColumnComponent;


    constructor(private http: Http, public dataService: DataService, public dashboardDataUtil: DashboardDataUtility) {}

    ngOnInit() {
        // console.log("graph view called");

        //this.setChartOptions();
        // return this.warehouseDataPromise = new Promise((resolve, reject) => {
        //     this.loadWareHouseData().then(json => {
        //         this.dataLoaded = true;
        //         this.warehouseData = json;
        //         this.setChartOptions();
        //         resolve(this.warehouseData);
        //     });
        // });

        if (this.moment && !this.moment.aggregateData) {
            this.calculatedData = [this.dashboardDataUtil.getSeriesQuestionValueSum(this.moment.jsonData, this.moment.questionsArray)];
        }

        this.setChartOptions();
        this.dataLoaded = true;

        this.dataService.getObservable(RE_RENDER_GRAPH).subscribe((result) => {
            //this.dataLoaded = true;
            this.calculatedData = result;
            if (this.selectedCompType === "moments") {
                this.calculatedData = result.data;
                this.questionsString = result.questionString;
                this.questionLabels = result.questionLabel;
                this.chartType = result.chartType;
                this.charttitle = result.title;
                this.dataFormat = result.dataFormat;
            }

            this.setChartOptions();
            if (this.chartType === 'spline') {
                this.dataService.emitData(RE_RENDER_SPLINE_GRAPH, [{
                    data: this.data,
                    serieslabels: this.serieslabels,
                    legendlabels: this.legendlabels,
                    categorylabels: this.categorylabels,
                    chartoptions: this.chartoptions
                }]);
            }
            else if (this.chartType === 'stackedchart') {
                this.dataService.emitData(RE_RENDER_STACKEDCOLUMN_GRAPH, [{
                    data: this.data,
                    serieslabels: this.serieslabels,
                    legendlabels: this.legendlabels,
                    categorylabels: this.categorylabels,
                    chartoptions: this.chartoptions,
                    stacking: this.chartStacking,
                    columnType: this.columnType
                }]);
            }
            else if (this.chartType === 'column') {
                this.dataService.emitData(RE_RENDER_COLUMN_GRAPH, [{
                    data: this.data,
                    serieslabels: this.serieslabels,
                    legendlabels: this.legendlabels,
                    categorylabels: this.categorylabels,
                    chartoptions: this.chartoptions,
                    min: this.min,
                    max: this.max,
                    columnType: this.columnType
                }]);
            }

        });
    }

    loadWareHouseData() {
        //return this.http.get('assets/data/dataWarehouse.json').toPromise().then(response => response.json());
    }

    setChartOptions() {
        this.chartoptions = {};
        this.data = {};
        this.serieslabels = [];
        this.categorylabels = [];
        this.legendlabels = [];

        _.merge(this.chartoptions, { chart: { backgroundColor: '#fff' }, xAxis: { labels: { style: { 'color': '#333' } } }, yAxis: { labels: { style: { 'color': '#333' } },
                alternateGridColor: 'rgb(240, 241, 242)' }, legend: { itemStyle: { 'color': '#333'}} });

        // if (calledFrom != 'reinit') {
        //     // Add export options for chart
        //     _.merge(this.chartoptions,  { exporting: { chartOptions: { plotOptions: { series: {
        //             dataLabels: {
        //                 // Enables labels with the actual values over the data points for exported chart.
        //                 enabled: true
        //             } } } },
        //         // Means it won't use the highcharts server to export - IE 8 and 9 won't work.
        //         fallbackToExportServer: false }
        //     });
        // }


        this.chartoptions = JSON.stringify(this.chartoptions);

        let questionsArray = this.questionsString.split(',');
        let questionLabels = this.questionLabels.split(',');
        let metric1, metric2, metric3;    

        if(this.columnType === "questions") {
            this.serieslabels = this.stackArray;           

            for (var i = 0; i < questionsArray.length; i++) {
                this.data[questionsArray[i]] = [];

                for(j = 0; j < this.calculatedData.length; j++ ){
                    var ques = this.calculatedData[j]["QuestionKey"]
                    if(questionsArray[i] === ques) {
                        this.data[questionsArray[i]].push(this.calculatedData[j]);                    
                    }
                }
            }

            for (var j = 0; j < questionsArray.length; j++) {
                this.categorylabels.push(questionsArray[j]);
            }

            for (var j = 0; j < questionLabels.length; j++) {
                this.legendlabels.push(questionLabels[j]);
            }
        }
        else if(this.columnType === "multiattempt")
        {
            let calcData = this.calculatedData[0];            
            for(let i=0; i < calcData.length; i++) {                
                this.data[this.stackArray + "-" + calcData[i]] = [];                
                this.serieslabels.push(this.stackArray + "-" + calcData[i]);
                this.legendlabels.push(this.stackArray + "-" + calcData[i])
                this.data[this.stackArray + "-" + calcData[i]].push(this.calculatedData[1][this.stackArray + "-" + calcData[i]]);
                this.categorylabels.push(this.stackArray + "-" + calcData[i]);
            }
        }
        else {

            for (var i = 0; i < questionsArray.length; i++) {
                this.data[questionsArray[i]] = [];

                this.serieslabels.push(questionsArray[i]);
                this.legendlabels.push(questionLabels[i]);

                for (var j = 0; j < this.calculatedData.length; j++) {
                    this.data[questionsArray[i]].push(this.calculatedData[j][questionsArray[i]]);
                }
            }

            for (var j = 0; j < this.calculatedData.length; j++) {
                this.categorylabels.push(this.calculatedData[j].fromDate);
            }
        }      

        if (this.chartType === 'stackedchart') {
            if (this.selectedComponent == 'scorecomposition') {
                this.chartStacking = 'percent';
            }
            else {
                this.chartStacking = 'normal';
            }
        }

        if (this.dataFormat === 'percent') {
            this.min = 0;
            this.max = 100
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/datawarehousegraph/graphView.ts